import { Show } from '../types';

export const shows: Show[] = [


    {
    id: 4,
    date: new Date('2025-06-05T20:00:00'),
    city: 'New York',
    venue: 'My Venue',
    time: new Date('2025-06-05T19:00:00'),
    ticketInfo: 'Starting at $70',
    ticketLink: '',
    image: 'https://i.ibb.co/bMTxSLSr/B3.png',
    description: 'Southwest Tour with Cephalic Carnage, A\\&P, and Sex Prisoner',
    showInHome: false,
    flightInfo: {
      arrival: 'Wednesday June 4, IAD 6:40PM - DEN 8:45PM, Confirmation # 36C8GW'
    },
    hotelInfo: {
      name: 'Hyatt Regency Denver Tech Center',
      address: '7800 E Tufts Ave, Denver, CO 80237',
      checkIn: 'June 4',
      checkOut: 'June 6',
      rooms: '2 Nights, 5 Adults, 3 Rooms'
    }
  },

 
  {
    id: 3,
    date: new Date('2025-06-05T20:00:00'),
    city: 'Denver, CO',
    venue: 'The Gothic Theater',
    time: new Date('2025-06-05T19:00:00'),
    ticketInfo: 'Starting at $35',
    ticketLink: 'https://example.com/tickets/denver',
    image: 'https://i.ibb.co/RpzYrmwp/B3.png',
    description: 'Southwest Tour with Cephalic Carnage, A\\&P, and Sex Prisoner',
    showInHome: false,
    flightInfo: {
      arrival: 'Wednesday June 4, IAD 6:40PM - DEN 8:45PM, Confirmation # 36C8GW'
    },
    hotelInfo: {
      name: 'Hyatt Regency Denver Tech Center',
      address: '7800 E Tufts Ave, Denver, CO 80237',
      checkIn: 'June 4',
      checkOut: 'June 6',
      rooms: '2 Nights, 5 Adults, 3 Rooms'
    }
  },

  {
    id: 2,
    date: new Date('2025-05-17T17:30:00'),
    city: 'Munster, IN',
    venue: 'Three Floyds Brewing - Dark Lord Day',
    time: new Date('2025-05-17T17:30:00'),
    ticketInfo: 'Festival Entry Required',
    ticketLink: 'https://example.com/tickets/dark-lord-day',
    image: 'https://i.ibb.co/2YM1xfqY/B2.png',
    description: 'Special performance at Dark Lord Day 2025. Set time: 5:30 PM - 6:30 PM',
    showInHome: true,
    hotelInfo: {
      name: 'Springhill Suites',
      address: '9651 Calumet Ave, Munster, IN 46321',
      checkIn: 'May 17',
      checkOut: 'May 18',
      notes: 'Late check-in on May 17th arranged',
      rooms: '3 rooms x 2 nights'
    },
    schedule: 'Performance at 5:30 PM - 6:30 PM, City-Mandated Hard Sound Curfew: 9:00 PM'
  },


  {
    id: 1,
    date: new Date('2025-05-16T17:00:00'),
    city: 'Vancouver, BC',
    venue: 'Modified Ghost Fest',
    time: new Date('2025-05-16T17:00:00'),
    ticketInfo: 'Festival Entry Required',
    ticketLink: 'https://example.com/tickets/ghost-fest',
    image: 'https://i.ibb.co/WvhM2y40/B1.png',
    description: 'Joining the lineup at Modified Ghost Fest for an evening of intense metal.',
    showInHome: true,
    flightInfo: {
      arrival: 'Thursday May 15th, 5:10 PM - 10:18 PM, UA 1580 ORD - YVR',
      departure: 'Saturday May 17th, 6:15 AM – 12:32 PM, United Air Canada YVR–ORD'
    },
    hotelInfo: {
      name: 'The Parker Hotel Vancouver',
      address: '1379 Howe St, Vancouver, BC V6Z 2R5 Canada',
      checkIn: 'May 15',
      checkOut: 'May 17',
      rooms: '3 rooms x 2 nights'
    }
  }
];